import { useApiClient } from '@m43/core';
import { UnitsTabResource } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';
import { TAB_QUERY_CACHE_TIME } from '../tabs/constants';

export function useEventUnitsTabQuery(props: { eventId?: number }) {
    const { eventId } = props;
    const apiClient = useApiClient();
    return useQuery(
        ['unitsTab', eventId] as const,
        ({ queryKey }) => {
            return apiClient
                .request<UnitsTabResource.GetUnitsTab>({
                    method: 'GET',
                    url: `units_tab/${queryKey[1]}/`,
                })
                .then((data) => {
                    return data.data.data;
                });
        },
        {
            cacheTime: TAB_QUERY_CACHE_TIME,
            enabled: !!eventId,
        }
    );
}
